import React, { useState, useEffect } from "react";
import MainContainer from "./components/MainContainer";
import Navbar from "./components/Navbar";
import Auth from "./components/Auth";
import "./App.css";
import { useSelector, useDispatch } from "react-redux";
import { logoutAndClearData, setActiveComponent } from "./redux/slices/authSlice";

function App() {
  const [isToggleButtonHidden, setIsToggleButtonHidden] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(isMobile);

  const isAuthenticated = useSelector(state => state.auth.isAuth);
  const gateways = useSelector(state => state.gateways.data);
  const dispatch = useDispatch();

  const handleNavItemSelect = component => {
    dispatch(setActiveComponent(component));
  };

  const handleSignOut = () => {
    // console.log("User signed out");
    dispatch(logoutAndClearData());
  };

  const toggleNavbarCollapse = () => {
    setIsNavbarCollapsed(prevState => !prevState);
  };

  useEffect(() => {
    if (gateways.length === 0) {
      dispatch(setActiveComponent("AddGateway"));
    } else {
      dispatch(setActiveComponent("ManageGateways"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="flex h-screen">
      {!isAuthenticated ? (
        <Auth />
      ) : (
        <>
          <Navbar
            isMobile={isMobile}
            onSignOut={handleSignOut}
            onNavItemSelect={handleNavItemSelect}
            isNavbarCollapsed={isNavbarCollapsed}
            toggleNavbarCollapse={toggleNavbarCollapse}
            isToggleButtonHidden={isToggleButtonHidden}
          />

          <MainContainer
            isMobile={isMobile}
            isNavbarCollapsed={isNavbarCollapsed}
            toggleNavbarCollapse={toggleNavbarCollapse}
            setIsToggleButtonHidden={setIsToggleButtonHidden}
          />
        </>
      )}
    </div>
  );
}

export default App;
